import BackendClient from './../services/backendClient';
import { readApiEndpointV1 } from "../utils/config";

export const getApps = (accountId) => BackendClient.get(`${readApiEndpointV1}accounts/${accountId}/apps`, false);
